import React from "react";
import FeedBackSection from "../components/FeedBack/FeedBackSection";

const FeedBack = () => {
    return <FeedBackSection />;
};

export default FeedBack;
